import React from 'react';
import { COLORS } from '../../../styles/tokens';
import NewOrderIcon from './NewOrderIcon';

export const fieldLabelStyle = { fontSize: 12, fontWeight: 600, color: COLORS.textMid, marginBottom: 5, display: 'block' };

// Hvit 52 px-boks med ikon foran (designets «Fld»). Barn (input/select) fyller resten av raden.
export default function IconField({ label, icon, htmlFor, children, style }) {
  return (
    <div style={style}>
      {label && <label htmlFor={htmlFor} style={fieldLabelStyle}>{label}</label>}
      <div style={styles.box}>
        {icon && <span style={{ color: COLORS.brandPanel, display: 'flex' }}><NewOrderIcon name={icon} size={19} /></span>}
        {children}
      </div>
    </div>
  );
}

export const bareInputStyle = {
  flex: 1, minWidth: 0, height: '100%', border: 'none', outline: 'none', background: 'transparent',
  fontSize: 15.5, fontWeight: 600, color: COLORS.textDark, fontFamily: 'inherit',
};

const styles = {
  box: {
    height: 52, borderRadius: 14, background: COLORS.white, border: `1px solid ${COLORS.border}`,
    display: 'flex', alignItems: 'center', gap: 10, padding: '0 14px', boxSizing: 'border-box',
  },
};
